





















import { defineComponent, ref, computed, onMounted, onUpdated, nextTick } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true,
    },
    lines: {
      type: Number,
      default: 3,
    },
    additionalContainerCss: {
      type: String,
      default: '',
    },
    additionalContentCss: {
      type: String,
      default: '',
    },
    additionalContentExpandedCss: {
      type: String,
      default: '',
    },
    hasMore: {
      type: Boolean,
      default: true,
    },
    moreText: {
      type: String,
      default: 'Show more',
    },
    lessText: {
      type: String,
      default: 'Show less',
    },
    additionalAnchorCss: {
      type: String,
      default: '',
    },
    alignAnchors: {
      type: String as () => 'right' | 'left' | 'center' | 'justify' | 'start' | 'end',
      default: undefined,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const expanded = ref(false)
    const triggerShowMore = ref(false)
    const detail = ref<HTMLElement | null>(null)

    const additionalCss = computed(() => {
      return expanded.value ? props.additionalContentCss : props.additionalContentExpandedCss
    })

    const onClick = () => {
      expanded.value = !expanded.value
      emit('click', expanded.value)
    }

    const determineShowMore = () => {
      if (detail.value && detail.value.offsetHeight < detail.value.scrollHeight) {
        triggerShowMore.value = true
      } else {
        triggerShowMore.value = false
      }
    }

    onMounted(() => {
      nextTick(() => {
        determineShowMore()
      })
    })
    onUpdated(() => {
      nextTick(() => {
        determineShowMore()
      })
    })

    return { expanded, triggerShowMore, additionalCss, onClick, detail }
  },
})
